/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContemporaryLandingFeaturedModule_contemporaryLandingRow$ref: FragmentReference;
export type ContemporaryLandingFeaturedModule_contemporaryLandingRow = {|
  +items: ?$ReadOnlyArray<?{|
    +text?: ?string,
    +type?: ?string,
    +items?: ?$ReadOnlyArray<?{|
      +cta?: ?string,
      +description?: ?string,
      +imagePath?: ?string,
      +linkPath?: ?string,
      +title?: ?string,
    |}>,
  |}>,
  +$refType: ContemporaryLandingFeaturedModule_contemporaryLandingRow$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ContemporaryLandingFeaturedModule_contemporaryLandingRow",
  "type": "ContemporaryLandingRow",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "ContemporaryLandingRow",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "ContemporaryLandingFeaturedRowItem",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "cta",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "description",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "imagePath",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "linkPath",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "title",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            },
            (v0/*: any*/)
          ]
        },
        {
          "kind": "InlineFragment",
          "type": "ContemporaryLandingHeader",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "text",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '1f3eababd9b3e858c36965d5253db122';
module.exports = node;
